<template>
    <transition-group
        name="list"
        tag="div"
        class="fixed right-2 bottom-2 z-50 flex max-w-[300px] flex-col items-end space-y-3 lg:right-4 lg:bottom-4 lg:max-w-[480px]"
    >
        <button
            v-for="toast in toasts"
            :key="toast.key"
            @click="removeToast(toast.key)"
            class="flex items-center space-x-3 rounded p-4 shadow-xl"
            :class="{
                'border-green text-green border': toast.level === 'success',
                'border-primary text-primary border': toast.level === 'error',
            }"
        >
            <svg
                v-if="toast.level === 'success'"
                class="h-8 w-8 flex-shrink-0 lg:h-12 lg:w-12"
                width="140"
                height="140"
                viewBox="0 0 140 140"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="1"
                    y="1"
                    width="138"
                    height="138"
                    rx="69"
                    fill="white"
                    stroke="#009E6D"
                    stroke-width="2"
                />
                <path
                    d="M88.8893 55.5858C89.6703 54.8047 90.9363 54.8047 91.7174 55.5858C92.4984 56.3668 92.4984 57.6329 91.7174 58.4139L66.2721 83.8592C66.2688 83.8625 66.2665 83.8667 66.2633 83.87C65.8724 84.2609 65.3596 84.4553 64.8473 84.4549C64.8414 84.4549 64.8355 84.455 64.8297 84.4549C64.6022 84.4528 64.376 84.4102 64.1598 84.3309C64.1102 84.3128 64.0615 84.2925 64.0133 84.2704C63.8572 84.1985 63.708 84.1072 63.5709 83.993C63.524 83.954 63.4772 83.914 63.4332 83.87C63.4301 83.8669 63.4275 83.8633 63.4244 83.8602L48.5855 69.0213C47.8045 68.2403 47.8045 66.9733 48.5855 66.1922C49.3665 65.4116 50.6327 65.4115 51.4137 66.1922L64.8473 79.6258L88.8893 55.5858Z"
                    fill="#009E6D"
                />
            </svg>

            <svg
                v-else
                class="h-8 w-8 flex-shrink-0 lg:h-12 lg:w-12"
                width="140"
                height="140"
                viewBox="0 0 140 140"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="1"
                    y="1"
                    width="138"
                    height="138"
                    rx="69"
                    fill="white"
                    stroke="currentColor"
                    stroke-width="2"
                    class="text-primary"
                />
                <path
                    d="M91.7174 55.5858C92.4984 54.8047 92.4984 53.5387 91.7174 52.7576C90.9363 51.9766 89.6703 51.9766 88.8893 52.7576L70 71.647L51.1107 52.7576C50.3297 51.9766 49.0637 51.9766 48.2826 52.7576C47.5016 53.5387 47.5016 54.8047 48.2826 55.5858L67.172 74.4751L48.2826 93.3645C47.5016 94.1455 47.5016 95.4115 48.2826 96.1926C49.0637 96.9736 50.3297 96.9736 51.1107 96.1926L70 77.3032L88.8893 96.1926C89.6703 96.9736 90.9363 96.9736 91.7174 96.1926C92.4984 95.4115 92.4984 94.1455 91.7174 93.3645L72.828 74.4751L91.7174 55.5858Z"
                    fill="currentColor"
                    class="text-primary"
                />
            </svg>
            <span class="block text-sm font-bold">{{ toast.message }}</span>
        </button>
    </transition-group>
</template>

<script>
export default {
    data() {
        return {
            toasts: [],
        };
    },

    mounted() {
        // Globale showToast Funktion registrieren
        window.showToast = (message, level = 'error') => {
            this.addToast(message, level);
        };
    },

    methods: {
        addToast(message, level) {
            const key = Date.now() + Math.random();
            this.toasts.push({
                message,
                level,
                key,
            });

            setTimeout(() => {
                this.removeToast(key);
            }, 5000);
        },

        removeToast(key) {
            const index = this.toasts.findIndex((t) => t.key === key);
            if (index > -1) {
                this.toasts.splice(index, 1);
            }
        },
    },
};
</script>

<style>
.list-enter-active,
.list-leave-active {
    transition: all 0.3s;
}

.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
